import React from 'react'

import { Container } from './AdminSubHeader2Style'

const AdminSubHeader2 = props => {

    return (
        <Container id="adminSubHeader2">{props.children}</Container>
    )
}

export default AdminSubHeader2